<!-- =========================================================
     SOCIAL MEDIA
     ========================================================= -->

<div class="section-heading">

  <div>

    <span class="section-kicker">
      Social media
    </span>

    <h2>
      Social media links
    </h2>

    <p>
      Manage the social media profiles displayed
      on the public website.
    </p>

  </div>

</div>


<div class="panel social-panel">

  @if (loading) {

    <div class="empty-state large">

      <strong>
        Loading social media links...
      </strong>

    </div>

  } @else {

    <form
      (ngSubmit)="saveSocialSettings()"
      novalidate
    >

      <!-- =====================================================
           INTRO
           ===================================================== -->

      <div class="social-intro">

        <div>

          <span class="section-kicker">
            Public profiles
          </span>

          <h3>
            Connected social accounts
          </h3>

          <p>
            Add the social media accounts associated
            with the business. Only links saved here
            will appear on the public website.
          </p>

        </div>

        <button
          type="button"
          class="primary-btn add-social-btn"
          (click)="addSocialLink()"
        >
          + Add social link
        </button>

      </div>


      <!-- =====================================================
           EMPTY STATE
           ===================================================== -->

      @if (socialLinks.length === 0) {

        <div class="social-empty-state">

          <div class="social-empty-icon">
            🔗︎
          </div>

          <strong>
            No social media links configured
          </strong>

          <p>
            Add a social media account to begin
            displaying it on the public website.
          </p>

          <button
            type="button"
            class="primary-btn"
            (click)="addSocialLink()"
          >
            Add first social link
          </button>

        </div>

      } @else {

        <!-- ===================================================
             LINK LIST
             =================================================== -->

        <div class="social-links-list">

          @for (
            link of socialLinks;
            track $index;
            let i = $index
          ) {

            <article class="social-link-card">

              <div class="social-link-number">
                {{ i + 1 }}
              </div>


              <div class="social-link-fields">

                <!-- PLATFORM -->

                <div class="form-field">

                  <label
                    [for]="'social-platform-' + i"
                  >
                    Platform
                  </label>

                  <select
                    [id]="'social-platform-' + i"
                    [name]="'socialPlatform-' + i"
                    [(ngModel)]="link.platform"
                  >

                    @for (
                      platform of socialPlatforms;
                      track platform
                    ) {

                      <option
                        [value]="platform"
                        [disabled]="
                          isPlatformUsed(
                            platform,
                            i
                          )
                        "
                      >
                        {{
                          displayPlatformName(
                            platform
                          )
                        }}
                      </option>

                    }

                  </select>

                </div>


                <!-- CUSTOM PLATFORM -->

                @if (link.platform === 'Other') {

                  <div class="form-field">

                    <label
                      [for]="'custom-platform-' + i"
                    >
                      Platform name
                    </label>

                    <input
                      [id]="'custom-platform-' + i"
                      [name]="'customPlatform-' + i"
                      [(ngModel)]="
                        link.customPlatform
                      "
                      placeholder="Platform name"
                      autocomplete="off"
                    />

                  </div>

                }


                <!-- URL -->

                <div
                  class="form-field social-url-field"
                >

                  <label
                    [for]="'social-url-' + i"
                  >
                    Profile URL
                  </label>

                  <input
                    [id]="'social-url-' + i"
                    [name]="'socialUrl-' + i"
                    type="url"
                    [(ngModel)]="link.url"
                    placeholder="https://..."
                    autocomplete="url"
                  />

                </div>

              </div>


              <!-- REMOVE -->

              <div class="social-link-actions">

                <button
                  type="button"
                  class="danger-outline-btn"
                  (click)="removeSocialLink(i)"
                >
                  Remove
                </button>

              </div>

            </article>

          }

        </div>


        <!-- ===================================================
             ADD ANOTHER
             =================================================== -->

        <div class="add-another-row">

          <button
            type="button"
            class="text-btn"
            (click)="addSocialLink()"
          >
            + Add another social link
          </button>

        </div>

      }


      <!-- =====================================================
           SAVE
           ===================================================== -->

      <div class="form-actions social-save-actions">

        <span class="saved-detail">
          Changes take effect immediately after saving.
        </span>

        <button
          type="submit"
          class="primary-btn"
          [disabled]="saving"
        >
          @if (saving) {
            Saving...
          } @else {
            Save social media links
          }
        </button>

      </div>

    </form>

  }

</div>